export function removeSpaces(str) {
    return str.replace(/\s+/g, '');
}


export function capitalizeWords(str) {
    return str.split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ');
}